export default function (token = null, action) {
  if (action.type === "setToken") {
    return action.token;
  }
  return token;
}
